import startsWith from "lodash/startsWith";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStableContext } from "../rill/RillReact/share/base";
import { isPushOrPerformClient } from "../utils/user-helpers";
import SvgIcon from "./SvgIcon";
import ThemeToggler from "./ThemeToggler";

function Leftbar() {
  const { t } = useTranslation("dashboard");
  const { locals } = useStableContext();

  const { pathname, currentActiveUser, activeUserToRequest } = locals;
  const userIsCoach = currentActiveUser.permissions?.includes("coach");
  const userIsAdmin = currentActiveUser.permissions?.includes("admin");
  const [expanded, setExpanded] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(null);
  useEffect(() => {
    setViewportWidth(window.innerWidth);
    window.addEventListener("resize", () => {
      setViewportWidth(window.innerWidth);
    });
  }, []);
  const programLibraryCondition =
    userIsAdmin ||
    !(
      userIsCoach ||
      (currentActiveUser.coach && !currentActiveUser.coach.inactive)
    );
  const toggleMenu = () => {
    setExpanded(!expanded);
    handleDashboardPaddings();
  };
  const handleDashboardPaddings = () => {
    // Adjust Padding for header Wrapper
    const nav = document.querySelector('header[role="main"]');
    if (nav && viewportWidth > 960)
      nav.style.margin = expanded ? "0px 0px 0px 4rem" : "0px 0px 0px 15rem";
  };
  const isSubscriber = isPushOrPerformClient(activeUserToRequest);
  const isMember = !!activeUserToRequest.membership;
  return (
    <aside role="main" open={expanded ? true : undefined}>
      <SvgIcon
        src={"/img/new-icons/arrow-square-right.svg"}
        onClickFn={() => toggleMenu()}
        classNames={expanded ? "expanded" : ""}
        id="handle-menu"
      />
      <div>
        <div className="msb-logo"></div>
      </div>
      <div className="nav-content">
        <ul>
          <li aria-current={startsWith(pathname, "/dashboard/calendar")}>
            <a href="/dashboard/calendar/">
              <div>
                <SvgIcon
                  src="/img/new-icons/calendar-ico-white.svg"
                  noFilterOnLight={startsWith(pathname, "/dashboard/calendar")}
                />
              </div>
              <span>{t("nav.calendar")}</span>
            </a>
          </li>

          <li aria-current={startsWith(pathname, "/dashboard/program-builder")}>
            <a href="/dashboard/program-builder">
              <div>
                <SvgIcon
                  className="dumbbell"
                  src="/img/new-icons/dumbbell.svg"
                  noFilterOnLight={startsWith(
                    pathname,
                    "/dashboard/program-builder"
                  )}
                />
              </div>
              <span>
                {isSubscriber || isMember
                  ? t("nav.programLibrary")
                  : t("nav.myPrograms")}
              </span>
            </a>
          </li>

          {programLibraryCondition && !isSubscriber && !isMember && (
            <li
              aria-current={startsWith(pathname, "/dashboard/program-library")}
            >
              <a href="/dashboard/program-library">
                <div>
                  <SvgIcon
                    className="dumbbell"
                    src="/img/new-icons/layer-group.svg"
                    noFilterOnLight={startsWith(
                      pathname,
                      "/dashboard/program-library"
                    )}
                  />
                </div>
                <span>{t("nav.programLibrary")}</span>
              </a>
            </li>
          )}

          <li aria-current={startsWith(pathname, "/dashboard/metrics")}>
            <a href="/dashboard/metrics/exercise-history">
              <div>
                <SvgIcon
                  src="/img/new-icons/rep-max-ico.svg"
                  noFilterOnLight={startsWith(pathname, "/dashboard/metrics")}
                />
              </div>
              <span>{t("nav.reports")}</span>
            </a>
          </li>
        </ul>
      </div>
      <footer>
        <div className="theme-container">
          <ThemeToggler expanded={expanded} />
        </div>
      </footer>
    </aside>
  );
}

export default React.memo(Leftbar);
